export enum OrderPagesURL {
  CART = '/cart',
  SHIPPING = '/checkout/shipping',
  PAYMENT = '/checkout/payment',
}
export type ItemsCountType = {
  count: number;
  hasTitle?: boolean;
};